<template>
	<div class=" sub-top pa-10">

		<div class="">
			<div>
				<v-icon :class="crown">mdi mdi-crown</v-icon>
				<span class="color-primary font-weight-bold">{{ user.member_id}}({{ user.member_name}})</span> 님
				<span class="">반갑습니다.</span>
			</div>
			<div
				class="mt-10"
			>
				<div class="text-right font-weight-bold">
					보유 포인트: {{ user.member_point | makeComma }} P
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'SubTop'
		, props: ['user', 'program', 'codes']
		, data: function(){
			return {
				items_menu: [
					{
						name: 'point'
						, title: '포인트 내역'
						, to: 'PointHistory'
						, not_view: true
					}
					, {
						name: 'point'
						, title: '포인트 결제 내역'
						, to: 'PointList'
						, not_view: true
					}
					, {
						name: 'present'
						, title: '포인트 선물'
						, to: 'PointPresent'
						, not_view: true
					}
					, {
						name: 'present'
						, title: '주문 내역'
						, to: 'OrderList'
						, params: {
							type: 'order'
						}
					}
					, {
						name: 'issue'
						, title: '취소/환불'
						, to: 'OrderCancel'
						, params: {
							type: 'cancel'
						}
					}
					, {
						name: 'qna'
						, title: '1:1문의'
						, to: 'CustomerCenter'
						, params: {
							b_code: 'b_qna'
						}
					}
					, {
						name: 'wish'
						, title: '관심상품'
						, to: 'Wish'
					}
				]
			}
		}
		, computed: {

			item: function(){
				let t = {
				}

				this.items_menu.filter( (item) => {
					if(item.to == this.$route.name){
						t = item
					}
				})

				return t
			}

			, crown: function(){
				let t = ''

				this.codes.M001.items.filter( (item) => {
					if(item.code_index == this.user.member_level){
						t = 'crown-' + item.code_color
					}
				})

				return t
			}
		}
		, methods: {
			toModify: function(){
				this.$bus.$emit('to', {name: 'MyPage'})
			}
			, toMenu: function(item){
				this.$bus.$emit('to', {name: item.to, params: item.params})
			}
			, reload: function(){
				document.location.reload()
			}
		}
		, created() {

		}
	}
</script>

<style>

	.crown-bronze { color: #CD7F32 !important;}
	.crown-silver { color: silver !important;}
	.crown-gold { color: gold !important;}
	.crown-vip { color: violet !important;}
</style>